import React, { useEffect, useState } from 'react';
import { UiComponents } from "@simulanisindia/ui";
import { removeDuplicatesValue, removeMatchedValues, toggleArraySingleValue } from '../../../utils/general';
import PermissionCardSkelton from '../../Skeleton/PermissionCardSkelton';

const PermissionCard = ({ onlyView = false, search, heading, permissions = [], selectPermissions, setSelectPermissions }) => {
    const { SimCheckBox } = UiComponents;
    const [permissionList, setPermissionList] = useState([]);
    const [allPermissionIds, setAllPermissionIds] = useState([]);
    const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        setLoading(true);
        setPermissionList(permissions);
        let allIds = permissions?.map(e => e.id).flat(Infinity) || [];
        setAllPermissionIds(allIds);
        setLoading(false);
    }, [permissions]);

    const handleSelectAllTabPermission = (e) => {
        if (e.target.checked) {
            let allPermissions = [...selectPermissions, ...allPermissionIds];
            setSelectPermissions(removeDuplicatesValue(allPermissions));
        } else {
            setSelectPermissions(removeMatchedValues(selectPermissions, allPermissionIds));
        }
    }

    useEffect(() => {
        setChecked(allPermissionIds.length === 0 ? false : allPermissionIds.every(e => selectPermissions.includes(e)));
    }, [allPermissionIds, selectPermissions]);

    const handleSelectSinglePermission = (id) => {
        setSelectPermissions(toggleArraySingleValue(selectPermissions, id));
    }

    let filterPermissionList = permissionList.filter(permission =>
        !search || permission.displayName.toLowerCase().includes(search.toLowerCase())
    )

    return (
        <div className="permission-card">
            {
                loading ?
                    <> <PermissionCardSkelton />  </>
                    :
                    <>
                        <div className="permission-header">
                            <h5>{heading} <span className='extrass'>Permissions</span></h5>
                            {allPermissionIds.length > 0 &&
                                <div className='d-flex gap-2'>
                                    <SimCheckBox disabled={onlyView} checked={checked} onChange={handleSelectAllTabPermission} />
                                    <p>Select All</p>
                                </div>}
                        </div>
                        <div className='permission-body'>
                            {filterPermissionList?.map((permission, index) => (
                                <div key={index} className='permission-body-divide'>
                                    <SimCheckBox disabled={onlyView} checked={selectPermissions.includes(permission.id)} onChange={() => handleSelectSinglePermission(permission.id)} />
                                    <div>
                                        <h5>{permission.displayName}</h5>
                                        <p>{permission.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>

            }

        </div>
    );
};

export default PermissionCard;
